import { render } from "./MsOffice.vue?vue&type=template&id=5ac11f53&scoped=true"
import script from "./MsOffice.vue?vue&type=script&lang=js"
export * from "./MsOffice.vue?vue&type=script&lang=js"

import "./MsOffice.vue?vue&type=style&index=0&id=5ac11f53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac11f53"]])

export default __exports__